import { getItemsFromCollection } from "directus/src/operations";

export async function fetchInProgressJobsCount() {
  try {
    const response = await getItemsFromCollection("jobs", {
      aggregate: { countDistinct: ["id"] },
      filter: {
        status: { _eq: "in_progress" },
        coordinator: { user: { _eq: "$CURRENT_USER" } },
      },
    });

    return response?.[0]?.countDistinct.id || 0;
  } catch (error) {
    console.error(error);

    throw error;
  }
}

export async function fetchReviewJobsCountForCoordinator() {
  try {
    const response = await getItemsFromCollection("jobs", {
      aggregate: { countDistinct: ["id"] },
      filter: {
        status: { _eq: "in_review" },
        coordinator: { user: { _eq: "$CURRENT_USER" } },
      },
    });

    return response?.[0]?.countDistinct.id || 0;
  } catch (error) {
    console.error(error);

    throw error;
  }
}

export async function fetchPendingReviewEntriesForJobCoordinator() {
  try {
    const query = {
      fields: ["logged_hours"],
      filter: {
        approved_hours: { _null: true },
        unapproved_hours: { _null: true },
        logged_hours: { _gt: 0 },
        job: { coordinator: { user: { _eq: "$CURRENT_USER" } } },
      },
    };

    const response = await getItemsFromCollection("timesheet", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
